module.exports = __webpack_public_path__ + "static/media/與書對話.75d61c44.png";